module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-PW-Australia-2-Landing-Page.98f710a7.webp";